import React, { useContext } from 'react';
import { LineupContext } from '../context/LineupContext';
import _ from 'lodash';
import { WithPicker } from '../context/PickerContext';
import { WithScoreDetails } from '../context/ScoreDetailsContext';
import { WithLineViewTabs } from '../context/LineViewTabsContext';
import { LineTabs } from './LineTabs';
import { Field } from './Field';
import { LineupStats } from './LineupStats';
import { LineupPhaseAndCountdown } from './LineupPhaseAndCountdown';

export const LineupInner: React.FC = () => {
  const {
    lineup,
  } = useContext(LineupContext);

  const Content = <div className="neo__lineup">
    <LineupPhaseAndCountdown />
    <LineupStats />
    <LineTabs />
    <Field />
  </div>

  return <WithLineViewTabs>
    <WithScoreDetails>
      {lineup?.edit_info?.can_edit
        ? <WithPicker>{Content}</WithPicker>
        : Content}
    </WithScoreDetails>
  </WithLineViewTabs>;
};
